import { connect } from 'react-redux';
import AudioView from './audioView';
import { stopAudio } from './audioActions';
import { setIsFileLoadingFailed } from '../screen/screenActions';
import selectors from '../../rootSelectors';

const mapStateToProps = (state) => ({
    ...state.audio,
    assessment: selectors.getNextIncompleteMeasure(state),
});

const mapDispatchToProps = (dispatch) => ({
    stopAudio: () => {
        dispatch(stopAudio());
    },
    onAudioLoadingError: () => {
        dispatch(setIsFileLoadingFailed(true));
    },
});

const AudioContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(AudioView);

export default AudioContainer;
